import { useState, useEffect, useContext } from "react"
import _ from "lodash"
import axios from "axios"
import { useParams } from "react-router-dom"

// Context
import { UserContext } from "../../../context/userContext"

// Services
import { gpraUrl } from "../../../config/microservicesUrls"
import { endpoints } from "../../../config/gpraApiEndpoints"

export default function useGPRAStatus() {
  const [fetchingGPRA, setFetchingGPRA] = useState(false)
  const [showPopup, setShowPopup] = useState(false)
  const [ableToDelete, setAbleToDelete] = useState(false)
  const [gpraRecordId, setGpraRecordId] = useState("")
  const [dischargeCompleted, setDischargeCompleted] = useState(false)

  const userCtx = useContext(UserContext)
  const { idTemplate } = useParams()

  useEffect(() => {
    const isDischargeTemplate = idTemplate === "discharge_session"

    const noParticipantInCtx =
      _.isEmpty(userCtx.current_participant_id) ||
      _.isEmpty(userCtx.participant_membership_id)

    if (noParticipantInCtx) return

    const fecthGPRAService = async () => {
      setFetchingGPRA(true)
      try {
        const config = {
          headers: {
            Authorization: `Bearer ${userCtx.tokenGpra}`,
          },
          params: {
            gpra_participant_uuid: userCtx.current_participant_id,
            gpra_membership_uuid: userCtx.participant_membership_id,
            interview_type: "Discharge",
          },
        }
        const interviewStatus = await axios.get(
          `${gpraUrl()}${endpoints.INTERVIEW_STATUS}`,
          config
        )

        if (interviewStatus.status === 200) {
          const data = interviewStatus?.data

          setDischargeCompleted(data?.dischargeCompleted)
          setAbleToDelete(data?.ableToDelete)
          setShowPopup(true)

          if (data?.ableToDelete) {
            const gpraRecordId = data?.gpraRecord?.gpraRecordId
            setGpraRecordId(gpraRecordId)
          }
          if (data?.dischargeCompleted) {
            setShowPopup(false)
          }
        } else if (interviewStatus.status === 204) {
          setShowPopup(false)
        }
      } catch (error) {
        console.error("Error when fetching GPRA Service.", error)
      }
      setFetchingGPRA(false)
    }
    if (isDischargeTemplate) fecthGPRAService()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return [
    fetchingGPRA,
    showPopup,
    ableToDelete,
    gpraRecordId,
    dischargeCompleted,
  ]
}
